import React from "react";
import "./Loader.scss";

export default function Loader() {
  return (
    <div className="loader">
      <img src="/images/loader.gif" alt="" />
    </div>
  );
}
